
import { Vue, Component, Prop, toNative } from 'vue-facing-decorator';
import EmailTemplateRenderer from '../Templates/EmailTemplateRenderer.vue';
import { EmailTemplate } from '@/entities/Invite/EmailTemplateViewModel';
@Component({
  components:{
    EmailTemplateRenderer,
  },
})
class EmailPreviewPane extends Vue{
  @Prop({default: false}) showPreview!: boolean;
  @Prop() sendGridTemplate!: EmailTemplate;

  // Email icon on No email selected
  private emailIcon = require('@/assets/Images/Invite/email-envelope.svg');

  // Boolean flag to check for mobile view
  private isMobile = false;

  // Mounted life cycle hook
  private mounted(){
    if(window.innerWidth <= 767){
      this.isMobile = true;
    }else{
      this.isMobile = false;
    }
  }

  // Handler for emitting event to change page header
  private OnEditEmailClick(){
    this.$emit('change-page-header');
  }
}
export default toNative(EmailPreviewPane);
